import { reactive } from 'vue'

export const pageLoader = reactive({
  loading: true
})